var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cPicker',{attrs:{"show":_vm.show,"slots":_vm.slots,"valueKey":"patient_name","extraText":"添加就诊人"},on:{"change":_vm.change,"confirmClick":_vm.confirmClick,"extraClick":_vm.addPatient}})
}
var staticRenderFns = []

export { render, staticRenderFns }